export const FIRST_SLASH_AFTER_PROTOCOL = 3;
